import React from 'react'

export const RecaptchaIconNew = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>recaptcha icon</title>
    <path
      d="M8.0013 17.083C11.9133 17.083 15.0846 13.9117 15.0846 9.99967C15.0846 7.64506 13.9357 5.55878 12.168 4.27084M8.83464 18.6663L7.16797 16.9997L8.83464 15.333M8.0013 2.91634C4.08929 2.91634 0.917969 6.08766 0.917969 9.99967C0.917969 12.3543 2.06686 14.4406 3.83464 15.7285M7.16797 4.66634L8.83464 2.99967L7.16797 1.33301"
      stroke="#4A4C50"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
